import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MapComponent} from './components/map/map.component';
import {Warp10Connector} from './lib/Warp10Connector';
import {HttpClientModule} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {EventBus} from './lib/EventBus';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ColorPickerComponent} from './components/color-picker/color-picker.component';
import {AboutComponent} from './pages/about/about.component';
import {MainComponent} from './pages/main/main.component';
import {ParamsModalComponent} from './components/params-modal/params-modal.component';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {ShipListComponent} from './components/ship-list/ship-list.component';
import {NgxSliderModule} from 'ngx-slider-v2';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
  declarations: [
    AppComponent,
    ColorPickerComponent,
    MapComponent,
    AboutComponent,
    MainComponent,
    ParamsModalComponent,
    ShipListComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    NgxSliderModule,
    ReactiveFormsModule,
    ScrollingModule,
    FontAwesomeModule
  ],
  providers: [Warp10Connector, EventBus],
  bootstrap: [AppComponent]
})
export class AppModule {
}
